/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import React from 'react';
import { t } from 'i18next';
import UploadFileModal from './UploadFileModal';
import CustomTable from './table/CustomTable';
import DocumentStatusThreeApp from './Functionality/DocumentStatusThreeApp';
import ButtonAction from './buttons/ButtonAction';
import {TrashOutlineIcon} from './buttons/IconButtons';
import DeleteModal from '../pages/Modals/DeleteModal';
import {STATUS_MODEL} from '../enums/statusEnum';

const DocumentStatusThree = ({
    dataTable, optionDownload, documentId, docValue, setIsAllChecked, setSelectDocumentsForDelete,
    selectDocumentsForDelete, isAllChecked, setDocValue, createDocValue, downloadImg, userType, onUpdate, updated,
    showBtnDelete=true, deleteShowModal=false, setDeleteShowModal=()=>{}, handleDelete=()=>{}, disabled=false
}) => {

    const {showAttahModal, dataApi, setShowAttachModal,
        tableId, thead, tbody,
        handleDeleteAll, handleCheckboxChange, getActionsButtons,
    } = DocumentStatusThreeApp({
            dataTable, optionDownload, documentId, docValue, setIsAllChecked, setSelectDocumentsForDelete,
            selectDocumentsForDelete, isAllChecked, setDocValue, createDocValue, downloadImg, userType, onUpdate, updated, disabled
    });

    return (
        <>

            {(!disabled && showBtnDelete) &&
                <div className='d-flex justify-content-end'>
                    <ButtonAction
                        id='btn_vcd_delete'
                        name='delete'
                        className='btn-icon-delete my-2'
                        Icon={TrashOutlineIcon}
                        disabled={selectDocumentsForDelete?.length === 0}
                        onClick={()=>{
                            setDeleteShowModal(true);
                        }}
                    />
                </div>
            }

            <div className={"col-12"}>
                <CustomTable tableId={tableId}
                             checkbox={!disabled}
                             checkboxTitle={"de_/_select_all"}
                             isAllChecked={isAllChecked}
                             checkboxFixed={false}
                             onChangeCheckbox={handleDeleteAll}
                             handleCheckboxChange={handleCheckboxChange}
                             getActionsButtons={getActionsButtons}
                             thead={thead}
                             tbody={tbody}
                             columnActions={true}
                             selectedList={selectDocumentsForDelete}
                             listDisabled={[ {statusId: STATUS_MODEL.PENDING_TO_UPLOAD}, {statusId : STATUS_MODEL.DOCUMENT_VALIDATED } ]}
                />
            </div>


            {showAttahModal &&
                <UploadFileModal
                    titlen={t('upload_file')}
                    show={showAttahModal}
                    data={dataApi}
                    ApiType='supplierDocument'
                    createDocValue={createDocValue}
                    onHide={() => setShowAttachModal(false)}
                    onUpdate={() => {
                        if(onUpdate)
                            onUpdate();
                    }}
                    optionUpload={optionDownload}
                />
            }

            {deleteShowModal &&
                <DeleteModal
                    title_modal={t('delete_documents')}
                    data={selectDocumentsForDelete}
                    show={deleteShowModal}
                    onHide={() => setDeleteShowModal(false)}
                    element_modal={t('documents')}
                    isReset={setSelectDocumentsForDelete}
                    isAllReset={setIsAllChecked}
                    onClickFn={() => handleDelete(selectDocumentsForDelete)}
                />
            }
        </>
    );
};

export default DocumentStatusThree;
